<script>
import { VTextField } from 'vuetify/lib'

const clean = value => Number(String(value).replace(/[^0-9.]/g, ''))
const format = (value, options, prefix = '') => prefix + clean(value).toLocaleString('en-US', options)

export default {
  name: 'InputNumeric',
  props: {
    min: {
      type: Number,
      default: -1
    },
    max: {
      type: Number,
      default: -1
    },
    value: {
      required: true,
      type: [Number, String],
      default: 0
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      rules: {
        max: value => this.max < 0 || clean(value) <= this.max || `Must be less than ${format(this.max, this.options, this.$attrs.prefix)}`,
        min: value => this.min < 0 || clean(value) >= this.min || `Must be more than ${format(this.min, this.options, this.$attrs.prefix)}`
      }
    }
  },
  computed: {
    formattedValue () {
      return format(this.value, this.options)
    }
  },
  watch: {
    value () {
      this.preserveCursorPosition()
    }
  },
  methods: {
    getSpecialCharCount (str) {
      return str.replace(/[0-9]/g, '').length
    },
    input (newValue) {
      newValue = clean(newValue)
      this.$emit('input', newValue)
      if (![this.rules.min, this.rules.max].every(r => r(newValue) === true)) return
      this.$emit('update', newValue)
    },
    keypress ($event) {
      const { keyCode } = $event
      if (keyCode > 31 && (keyCode < 48 || keyCode > 57)) {
        $event.preventDefault()
      }
    },
    async preserveCursorPosition () {
      const inputRef = this.$refs.vtextfield.$refs.input
      const currentCursorLocation = inputRef.selectionStart
      const previousSpecialCharCount = this.getSpecialCharCount(inputRef.value)
      const selectAll = inputRef.value === '' || inputRef.value.length === previousSpecialCharCount

      await this.$nextTick()
      if (selectAll) return inputRef.select()
      const currentSpecialCharCount = this.getSpecialCharCount(inputRef.value)
      inputRef.selectionEnd = currentCursorLocation + (currentSpecialCharCount - previousSpecialCharCount)
    }
  },
  render (h) {
    return h(VTextField, {
      props: {
        rules: [this.rules.min, this.rules.max],
        value: this.formattedValue
      },
      attrs: {
        type: 'tel',
        ...this.$attrs
      },
      on: {
        ...this.$listeners,
        input: this.input,
        keypress: this.keypress
      },
      ref: 'vtextfield'
    })
  }
}
</script>
